import styled from "styled-components";

export const NewUserWelfareWrap = styled.div`
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: #fef6f2;
  border: 1px solid #f6be97;
  background-size: 100% 100%;
  color: rgba(238, 111, 46, 1);
  font-weight: 600;
  margin-bottom: 18px;
  .title {
    background: linear-gradient(104.14deg, #ee715f 2.8%, #eb4846 92.67%);
    height: 40px;
    line-height: 40px;
    color: white;
    padding: 0 10px;
    border-radius: 4px 0 0 4px;
    margin-left: -1px;
  }
  .welfare-content {
    padding: 0 11px;
  }
  .sub-title {
    color: rgba(100, 48, 14, 1);
    margin-right: 10px;
  }
  .line {
    color: rgba(223, 207, 197, 1);
    margin: 0 20px;
  }
  .count-down {
    display: inline-flex;
    height: 22px;
    line-height: 22px;
    text-align: center;
  }
  .count-down div {
    background: rgba(251, 228, 221, 1);
    border-radius: 4px;
    width: 30px;
    margin: 0 4px;
  }
`;
